import { Fragment } from 'react/jsx-runtime'

import { AstraCheckbox, AstraParagraph, AstraTimePicker, AstraTimePickerProps, day, format, getNewDateWithTime } from '~/astra'

import { withFieldGroup } from '../../Form/formHooks'
import { createFormFieldProps } from '../../Form/utils'
import { DayOpeningHours, defaultServicePeriod, FormServicePeriod, getDistinctIsoWeekdaysInRange } from './formState'

const DAY_LABELS = ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'] as const

type OpeningHoursDayRowProps = {
    value: DayOpeningHours
    onChange: (value: DayOpeningHours) => void
    label?: string
} & Pick<AstraTimePickerProps, 'error' | 'errorText'>

export function OpeningHoursDayRow({ label, value, onChange, error, errorText }: OpeningHoursDayRowProps) {
    const handleDayChange = (updates: Partial<DayOpeningHours>) => {
        onChange({ ...value, ...updates })
    }

    return (
        <div className={`grid max-w-xl ${error ? 'items-start' : 'items-center'} gap-4`} style={{ gridTemplateColumns: '80px 1fr auto 1fr 80px' }}>
            <Fragment key={label}>
                <AstraParagraph variant="body">{label}</AstraParagraph>
                <AstraTimePicker
                    value={value.open ? getNewDateWithTime(day(), value.open) : undefined}
                    onChange={time => handleDayChange({ open: time ? format(time, 'HH:mm') : '' })}
                    disabled={value.isClosed}
                    size="medium"
                    minTime={day().hour(6).minute(0)}
                    hourInterval={1}
                    minuteInterval={15}
                />

                <div>Til</div>
                <AstraTimePicker
                    value={value.close ? getNewDateWithTime(day(), value.close) : undefined}
                    onChange={time => handleDayChange({ close: time ? format(time, 'HH:mm') : '' })}
                    disabled={value.isClosed}
                    size="medium"
                    minTime={day().hour(6).minute(0)}
                    hourInterval={1}
                    minuteInterval={15}
                    error={error}
                    errorText={errorText}
                />
                <div className="flex items-center gap-2 self-center">
                    <AstraCheckbox checked={value.isClosed} onCheckedChange={checked => handleDayChange({ isClosed: checked === true })} />
                    <AstraParagraph variant="body">Stengt</AstraParagraph>
                </div>
            </Fragment>
        </div>
    )
}

const defaultOpeningHoursGroupValues: FormServicePeriod = defaultServicePeriod
export const OpeningHoursField = withFieldGroup({
    defaultValues: defaultOpeningHoursGroupValues,
    render: function Render({ group }) {
        const { startDate, endDate } = group.state.values
        const isoWeekdaysToRender = Array.from(getDistinctIsoWeekdaysInRange(startDate, endDate)).toSorted()
        return (
            <div className="flex flex-col gap-4">
                {isoWeekdaysToRender.map(isoWeekday => {
                    const dayIndex = Number(isoWeekday) - 1
                    return (
                        <group.Field name={`openingHours[${dayIndex}]`} key={isoWeekday}>
                            {field => <OpeningHoursDayRow label={DAY_LABELS[dayIndex]} value={field.state.value} {...createFormFieldProps(field)} />}
                        </group.Field>
                    )
                })}
            </div>
        )
    },
})
